import React, { useState } from 'react';
import { languages } from '../../staticData/languages';
import './toggleLanguage.css';
import LanguageSelection from '../../machineUI/LanguageSelection';
import { ReactComponent as Language_icon } from '../../Icons/Language_Icon.svg';

export default function ToggleLanguage(props) {
  const [show, setShow] = useState(false);

  let lan = languages;

  let style = null;

  if (props.p == 'p') {
    style = {
      position: 'absolute',
      left: '24vw',
      top: '190px',
      zIndex: 2000,
      width: '63px',
    };
  } else {
    style = {
      position: 'absolute',
      left: '7vw',
      top: '45px',
      zIndex: 2000,
      width: '63px',
    };
  }

  if (props.l) {
    let fl = props.l.map((i) => i.code);
    lan = languages.filter((item) => fl.includes(item.code));
  }

  if (props.l?.length > 1)
    return (
      <div className="cate-language">
        <Language_icon
          style={{
            cursor: 'pointer',
          }}
          className="language_icon"
          onClick={() => {
            setShow(true);
          }}
        />
        {/* <span
          style={{
            cursor: 'pointer',
          }}
          className="language-text"
          onClick={() => {
            setShow(true);
          }}
        >
          Select Language
        </span> */}
        <LanguageSelection
          setlangs={props.setlangs}
          langs={props.langs}
          lan={props.l}
          machineID={props.machineID}
          show={show}
          onHide={() => setShow(false)}
        />
      </div>
    );
  else return null;
}
